import React, { useState, useEffect } from 'react';
import axios from 'axios';
import DataTable, { ConditionalStyles, SortOrder, TableColumn } from 'react-data-table-component';
// import ContentWrapper from '../Layout/ContentWrapper';
// import FancyLoader from '../Common/FancyLoader';
// import { Card, CardBody } from 'reactstrap';
import { getDatagridUrlParams, DropdownIfc, paginationComponentOptions } from './utility-list';
import { getFiltersConfig } from './list-entities/ListColumnFilter';
import { ListColumn } from './list-entities/ListColumn';
import { IDatagrid, IResponse } from './datagrid';
import FilterWrapperForList from './FilterWrapperForList';

interface EntityListProps<T = any, S = any> {
  baseUrl: string;
  columns: ListColumn<T>[];
  withContext?: boolean;
  onContextRes?: (res: any) => void;
  dispatchFilter?: (filter: any) => void;
  dispatchPage?: (page: number) => void;
  dispatchSort?: (order: any) => void;
  listFilters?: any;
  listPage?: number;
  listSort?: any;
  mapData?: (c: S) => T;
  condRowStyles?: ConditionalStyles<T>[];
  onClickRow?: (row: T) => void;
  refresh?: boolean;
}

const toTableCol = (col: ListColumn<any>): TableColumn<any> => ({
  name: col.name,
  selector: col.selector,
  sortable: col.sortable,
  sortField: col.sortField as string,
  grow: col.grow,
  format: col.format,
  cell: col.cell,
  conditionalCellStyles: col.conditionalCellStyles,
});

const EntityList = ({
  baseUrl,
  columns,
  withContext,
  onContextRes,
  dispatchFilter,
  dispatchPage,
  dispatchSort,
  listFilters,
  listPage,
  listSort,
  mapData,
  condRowStyles,
  onClickRow,
  refresh,
}: EntityListProps) => {
  const [data, setData] = useState<any[]>([]);
  const [filters, setFilters] = useState<{ [index: string]: string }>({});
  const [loading, setLoading] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [page, setPage] = useState(1);
  const [filtersHash, setFiltersHash] = useState<string | boolean>(false);
  const [sortOrder, setSortOrder] = useState(listSort ? listSort.order : {});
  const [timeoutId, setTimeoutId] = useState<NodeJS.Timeout>();
  const [firstCharge, setFirstCharge] = useState(true);

  const filtersConfig = React.useMemo(() => getFiltersConfig(columns), [columns]);

  useEffect(() => {
    refreshList(page);
  }, [refresh]);

  const refreshList = (page) => {
    fetchData(page);
  };

  const fetchData = async (page: number, limit = perPage) => {
    setLoading(true);

    let _sortOrder = { ...sortOrder };
    if (firstCharge) {
      // page = listPage ? listPage : page;
      if (listSort) handleSort(listSort.order.column, listSort.order.direction, true);
      setFirstCharge(false);
    }
    // alert(page)
    const skip = limit * (page - 1);
    const params = getDatagridUrlParams(skip, limit, { ...filters }, filtersConfig, _sortOrder);
    const url = `${baseUrl}${params}`;
    // const url = `${baseUrl}/datagrid${params}`;

    const response = await axios.get<IResponse>(url, { withCredentials: true });

    // const response = dataToDelete;

    setData(mapData ? response.data.data.data.map(mapData) : response.data.data.data);
    setTotalRows(response.data.data.recordsTotal);
    setLoading(false);
  };

  const fetchContext = React.useCallback(async () => {
    if (withContext) {
      const url = `${baseUrl}/getContext`;
      const response = await axios.get<{ categoriaList: DropdownIfc[] }>(url, { withCredentials: true });

      if (onContextRes) {
        onContextRes(response.data);
      }
    }
  }, [baseUrl, withContext, onContextRes]);

  useEffect(() => {
    fetchContext();
  }, [fetchContext]);

  useEffect(() => {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    // @ts-ignore
    setTimeoutId(
      setTimeout(async () => {
        fetchData(1);
      }, 750)
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filtersHash, sortOrder]);

  const handlePageChange = (page: number) => {
    setPage(page);
    fetchData(page);
    if (dispatchPage) dispatchPage(page);
  };

  const handlePerRowsChange = async (newPerPage: number, page: number) => {
    setPerPage(newPerPage);
    setPage(page);
    fetchData(page, newPerPage);
  };

  const handleClick = (row: any) => {
    if (onClickRow) {
      onClickRow(row);
    }
  };

  const handleSort = (column: TableColumn<any>, sortDirection: SortOrder, firstCharge?: boolean) => {
    let order = { column: column, direction: sortDirection };
    if (!firstCharge) {
      setSortOrder(order);
      if (dispatchPage) dispatchPage(1);
      if (dispatchSort) dispatchSort({ order: order });
    }
  };

  const onChangeAnyFilter = (
    _filters: { [index: string]: string },
    filterHash: string | boolean,
    cleanFilters?: boolean
  ) => {
    setFilters({ ..._filters });
    setFiltersHash(filterHash);
    if (cleanFilters) {
      setSortOrder({});
      if (dispatchSort) dispatchSort({ order: {} });
    }

    if (dispatchFilter) dispatchFilter(_filters);

    if (!firstCharge) {
      if (dispatchPage) dispatchPage(1);
    }
  };

  const cols = React.useMemo(() => columns.map(toTableCol), [columns]);

  return (
    <div>
      <div className="content-heading">{/* <div>Lista de articulos de micro-global</div> */}</div>
      <div className=" card-default">
        <div className="">
          <div>
            <FilterWrapperForList
              initFilters={listFilters ? listFilters : []}
              filtersConfigList={filtersConfig}
              onChangeAnyFilter={onChangeAnyFilter}
              filtersHash={filtersHash}
            />

            <DataTable
              columns={cols}
              noDataComponent="No se encontraron registros"
              data={data}
              pagination
              paginationComponentOptions={paginationComponentOptions}
              paginationServer
              paginationTotalRows={totalRows}
              paginationDefaultPage={listPage ? listPage : 1}
              onChangeRowsPerPage={handlePerRowsChange}
              onChangePage={handlePageChange}
              onRowClicked={(row, e) => {
                e.preventDefault();
                handleClick(row);
              }}
              sortServer
              // @ts-expect-error
              onSort={handleSort}
              progressPending={loading}
              // progressComponent={/*<FancyLoader />*/}
              conditionalRowStyles={condRowStyles}
              sortIcon={
                <span className="mb-2">
                  <i className="fa fa-sort-down ml-2 mt-2 mb-2 mr-2"></i>
                </span>
              }
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default EntityList;
